import { post } from '@/api/request'

/**
 * 获取在线留言分页列表
 * @param {Object} params
 * @param {Object} params.entity   查询条件，如 { name: 'xxx' }
 * @param {number} params.pageNumber 当前页码（从 1 开始）
 * @param {number} params.pageSize   每页条数
 */
export function getOnlineMsg(params) {
  return post('/api/getOnlineMsg', params)
}
